import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { SanctumAuthService } from '@freesixtyfive/auth';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { AppMenuItem, menuItems } from '../../app.navigation';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-start-page',
  standalone: true,
  imports: [RouterModule, TranslateModule, CardModule, ButtonModule],
  templateUrl: './start-page.component.html',
  styleUrl: './start-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartPageComponent {
  #auth = inject(SanctumAuthService);
  #user = inject(UserService);

  firstName = computed(() => {
    if (!this.#auth.isAuth()) return '';
    return this.#user.getUser()?.firstName ?? '';
  });

  groups = computed(() => {
    const perms = this.#auth.permissions();

    return menuItems
      .map((item) => {
        if (item.items?.length) {
          const cards = item.items.filter(
            (child) =>
              child.dashboard &&
              (!child.permission || perms.includes(child.permission)),
          );
          return { labelKey: item.label!, icon: item.icon, cards };
        } else if (item.dashboard) {
          if (item.permission && !perms.includes(item.permission)) return null;
          return { labelKey: '', icon: item.icon, cards: [item] };
        }
        return null;
      })
      .filter(
        (
          group,
        ): group is {
          labelKey: string;
          icon: string | undefined;
          cards: AppMenuItem[];
        } => !!group && group.cards.length > 0,
      );
  });
}
